<template>
    <b-button
        id="coi-action-bar-reprint-label"
        @click="submit()"
        block
        size="sm"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        v-show="!userPreferenceStore.coi.lightMode"
    ><!-- button -->
        Rechnung
        <b-modal v-model="modalState" id="modal-missing-invoice" title="Rechnung existiert nicht" ok-only size="md" > Es wurde keine passende Rechnung zu dieser Kundenbestellung in der Datenbank gefunden.</b-modal>
    </b-button>
</template>
<script>
    import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

    export default {
        setup(){
            const userPreferenceStore = useUserPreferenceStore();
            return {userPreferenceStore}
        },        
        props: ['customerOrderId', 'customerOrderItemDeliveryAddition'],
        data() {
            return {
               modalState: false
             , httpRequestInProgress: false
            }
        },
        methods: {
            convertBase64ToBlob(contentType, data) // web: https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
            {
                const byteCharacters = atob(data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: contentType});
                return blob;
            },
            download(data, filename, type)
            {
                var file = new Blob([data], {type: type});
                if (window.navigator.msSaveOrOpenBlob) // IE10+
                    window.navigator.msSaveOrOpenBlob(file, filename);
                else { // Others
                    var a = document.createElement("a"),
                    url = URL.createObjectURL(file);
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);  
                    }, 0); 
                }
            },
            submit() 
            {
			    //const shippingId = this.customerOrderItemDeliveryAddition.shippingId;
                axios.get(`/customerorder/action/downloadinvoice/${this.customerOrderId}`)
                .then( response => {
                    if( "" == response.data || null == response.data || undefined == response.data)
                    {
                        this.modalState = true;
                    }
                    else
                    {
                        this.download(
                           this.convertBase64ToBlob('application/pdf', response.data.pdfBase64)
                         , `${response.data.number}.pdf`
                         , 'application/octet-stream'
                        );
                        //const dataUrl = `data:application/pdf;base64,${response.data.pdfBase64}`;
                        //window.location = dataUrl;
                    }
                }).catch(error => {
                    console.log(error)
                });
            }
        }
    }
</script>
